export enum TableDefaults {
    page = 0,
    size = 25
}